import { useAuthorizedLabel, useLocale } from '@gov-nx/core/service';
import {
	PageCode,
	useProfilROBReklamaceContextInstance,
} from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';

export const ProfileROBComplaintSubmitButton = ({
	formId,
}: {
	formId: string;
}) => {
	const { t } = useLocale(PageCode['profil-ROB']);
	const authLabel = useAuthorizedLabel();
	const { controls, formDefinition, isAuthorizationEnforced } =
		useProfilROBReklamaceContextInstance();

	const isProcessing = controls.processLoading;
	const isContactProvided =
		formDefinition.form.formMethods.watch('_useEmail') ||
		formDefinition.form.formMethods.watch('_usePhone');
	return (
		<Button
			isLoading={isProcessing}
			isDisabled={isProcessing || !isContactProvided}
			form={formId}
			nativeType="submit"
			color="primary"
			size="m"
			type="solid">
			{authLabel(t('akce.odeslat-reklamaci'), isAuthorizationEnforced)}
		</Button>
	);
};
